<template>
  <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
    <div class="modal-card" :class="{ embeded: embeded }">
      <section class="modal-card-body">
        <div v-show="!isLoggingIn">
          <InputWithValidation
            v-model="email"
            rules="required|email"
            type="email"
            :custom-error="logginError"
            :placeholder="$t('input-login-tooltip')"
            :label="$t('input-login')"
            @keyup.enter="enterPressed"
          />

          <InputWithValidation
            v-model="password"
            rules="required"
            type="password"
            password-reveal
            :placeholder="$t('input-password-tooltip')"
            :label="$t('input-password')"
            vid="password"
            @keyup.enter="enterPressed"
          />
          <CheckboxWithValidation v-model="acceptCookie" rules="accept-cookie" vid="acceptCookie">
            {{ $t("login-accept-cookie") }}
          </CheckboxWithValidation>
        </div>
        <LoadingSkeleton v-if="isLoggingIn" :loading-text="$t('login-connecting')" />
      </section>
      <footer v-if="!isLoggingIn" class="modal-card-foot">
        <b-button type="is-primary" :disabled="!acceptCookie" @click="handleSubmit(submit)">
          {{ $t("login") }}
        </b-button>
        <router-link :to="{ path: '/forgot-password/' + email }">
          {{ $t("forgot-password") }}
        </router-link>
      </footer>
    </div>
  </ValidationObserver>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { BButton } from "buefy"
import InputWithValidation from "@/views/inputs/InputWithValidation.vue"
import CheckboxWithValidation from "@/views/inputs/CheckBoxWithValidation.vue"
import ValidationObserver from "@/services/validation/ValidationObserver.vue"
import { LoginService } from "@/services/rest/login/LoginService"
import { AuthenticationDTO } from "@/model/bean/GeneratedDTOs"
import LoadingSkeleton from "../generic_components/LoadingSkeleton.vue"

export default defineComponent({
  name: "LoginView",
  components: {
    InputWithValidation,
    ValidationObserver,
    CheckboxWithValidation,
    LoadingSkeleton,
    BButton,
  },
  props: {
    embeded: Boolean,
  },

  emits: ["hide-drop-down"],
  data() {
    return {
      loginService: LoginService.INSTANCE,
      isLoggingIn: false,
      email: "",
      password: "",
      logginError: "",
      acceptCookie: true,
    }
  },
  mounted(): void {
    this.email = this.loginService.getLastSuccessfullEmail()
  },
  methods: {
    enterPressed(): void {
      this.submit()
    },
    submit(): void {
      this.isLoggingIn = true
      setTimeout(this.performLogin, 500)
    },
    async performLogin(): Promise<void> {
      try {
        const authentication = new AuthenticationDTO()
        authentication.courriel = this.email
        authentication.motDePasse = this.password

        await this.loginService.login(authentication)
        this.isLoggingIn = false
        // Nothing to do: user already re-routed after succesfull login (see LoginService.loginSucceeded())
      } catch (errorMessage) {
        this.isLoggingIn = false
        this.logginError = errorMessage as string
        if (this.logginError == this.$t("login-error-non-validated-email")) {
          this.$emit("hide-drop-down")
          await this.$router.push({
            name: "RegisterPending",
            state: {
              errorMessage: this.$t("login-error-non-validated-email").toString(),
              registrationMessage: this.$t("registerPage.mailsent").toString(),
              mail: this.email,
              initialResendMode: "true",
            },
          })
        }
      }
    },
  },
})
</script>
<style scoped>
.modal-card.embeded {
  width: 320px;
}
</style>
